module.exports = __webpack_public_path__ + "img/personalIcon.0b80c835.png";